import React from "react";
import { useNavigate } from "react-router-dom";

export default function Headerback(props) {
    let { showPage } = props;
    const navigate = useNavigate();

    function goBack(showPage) {
        if (showPage === 1) {
            navigate('/course');
        } else if (showPage === 2) {
            navigate('/afterclass');
        }
    }

    return (
        <header id="header"> 
            <span
                className="header-btn-left iconfont icon-fanhui1"
                onClick={() => goBack(showPage)}
            ></span>
            <span className="header-btn-right iconfont icon-yonghu"></span>
        </header>
    );
}